// src/pages/Dashboard.js
import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import Organisations from "../components/Organisations";
import Paiements from "../components/Paiements";
import Statistiques from "../components/Statistiques";
import ResetData from "../components/ResetData";

const TABS = [
  { id: "stats", label: "📊 Statistiques", icon: "📊" },
  { id: "orgs", label: "🏢 Organisations", icon: "🏢" },
  { id: "paiements", label: "💳 Paiements", icon: "💳" },
  { id: "reset", label: "🔴 Reset données", icon: "🔴" },
];

export default function Dashboard() {
  const { currentUser, deconnecter } = useAuth();
  const [activeTab, setActiveTab] = useState("stats");

  return (
    <div style={s.wrapper}>
      {/* Sidebar */}
      <aside style={s.sidebar}>
        <div style={s.sidebarHeader}>
          <div style={s.sidebarLogo}>🎟️</div>
          <div>
            <div style={s.sidebarTitle}>TomboLive</div>
            <div style={s.sidebarSubtitle}>Back-office</div>
          </div>
        </div>

        <nav style={s.nav}>
          {TABS.map((tab) => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
              style={{
                ...s.navItem,
                ...(activeTab === tab.id ? s.navItemActive : {}),
                ...(tab.id === "reset" ? s.navItemDanger : {}),
              }}>
              {tab.label}
            </button>
          ))}
        </nav>

        <div style={s.sidebarFooter}>
          <div style={s.adminEmail}>{currentUser?.email}</div>
          <button onClick={deconnecter} style={s.btnLogout}>🚪 Déconnexion</button>
        </div>
      </aside>

      {/* Contenu */}
      <main style={s.main}>
        <div style={s.mainHeader}>
          <h1 style={s.mainTitle}>
            {TABS.find((t) => t.id === activeTab)?.label}
          </h1>
          <div style={s.mainDate}>
            {new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
          </div>
        </div>

        <div style={s.content}>
          {activeTab === "stats" && <Statistiques />}
          {activeTab === "orgs" && <Organisations />}
          {activeTab === "paiements" && <Paiements />}
          {activeTab === "reset" && <ResetData />}
        </div>
      </main>
    </div>
  );
}

const s = {
  wrapper: { display: "flex", minHeight: "100vh", background: "#f7f8fc", fontFamily: "system-ui,sans-serif" },
  sidebar: { width: "240px", background: "linear-gradient(180deg,#1a3a8f,#2d1b69)", display: "flex", flexDirection: "column", flexShrink: 0 },
  sidebarHeader: { display: "flex", alignItems: "center", gap: "12px", padding: "1.5rem 1.25rem", borderBottom: "1px solid rgba(255,255,255,0.1)" },
  sidebarLogo: { fontSize: "2rem" },
  sidebarTitle: { color: "#fff", fontWeight: "800", fontSize: "1.1rem" },
  sidebarSubtitle: { color: "rgba(255,255,255,0.5)", fontSize: "0.75rem" },
  nav: { flex: 1, padding: "1rem 0.75rem", display: "flex", flexDirection: "column", gap: "4px" },
  navItem: { width: "100%", padding: "0.75rem 1rem", background: "none", border: "none", color: "rgba(255,255,255,0.7)", borderRadius: "8px", cursor: "pointer", textAlign: "left", fontSize: "0.9rem", fontWeight: "600" },
  navItemActive: { background: "rgba(255,255,255,0.15)", color: "#fff" },
  navItemDanger: { color: "rgba(255,100,100,0.8)", marginTop: "auto" },
  sidebarFooter: { padding: "1rem 1.25rem", borderTop: "1px solid rgba(255,255,255,0.1)" },
  adminEmail: { color: "rgba(255,255,255,0.5)", fontSize: "0.75rem", marginBottom: "8px", wordBreak: "break-all" },
  btnLogout: { width: "100%", padding: "0.6rem", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.8)", borderRadius: "8px", cursor: "pointer", fontSize: "0.85rem" },
  main: { flex: 1, display: "flex", flexDirection: "column", overflow: "auto" },
  mainHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1.5rem 2rem", background: "#fff", borderBottom: "1px solid #eee" },
  mainTitle: { fontSize: "1.4rem", fontWeight: "800", color: "#1a1a2e", margin: 0 },
  mainDate: { fontSize: "0.85rem", color: "#aaa" },
  content: { padding: "2rem", flex: 1 },
};
